module.exports = __webpack_public_path__ + "static/media/like_inactive.0437c0d1.svg";